declare global {
  interface Window {
    Trustpilot?: {
      loadFromElement: (el: HTMLElement, refresh?: boolean) => void
    }
  }
}

export const TRUSTPILOT_SCRIPT_URL = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'

export const loadTrustpilotScript = (): void => {
  if (document.querySelector(`script[src="${TRUSTPILOT_SCRIPT_URL}"]`)) {
    return
  }

  const script = document.createElement('script')
  script.src = TRUSTPILOT_SCRIPT_URL
  script.async = true
  document.head.appendChild(script)
}

export const renderTrustpilotBox = (el: HTMLElement | null): void => {
  if (el) {
    window.Trustpilot?.loadFromElement(el, true)
  }
}
